import React from "react";
import { observer } from "mobx-react";
import { useStores } from "../../hooks/useStores";
import { Redirect } from "react-router-dom";

export const RedirectToUserBoard: React.FC = observer(() => {
  const { session } = useStores();
  if (session.isLogged && session.user) {
    return <Redirect to={`/programs`} />;
  }

  return <Redirect to={`/login`} />;
});
